'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ctaClick = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.loadSaga = loadSaga;
exports.doPostCtaClick = doPostCtaClick;
exports.watchSaga = watchSaga;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _page = require('redux/modules/page');

var _page2 = require('redux/saga/selectors/page');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(loadSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doPostCtaClick),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchSaga);

var ctaClick = exports.ctaClick = function ctaClick(promoAlias) {
  return {
    type: 'HERO_CTA_CLICK', promoAlias: promoAlias
  };
};

function loadSaga(client) {
  return _regenerator2.default.wrap(function loadSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.put)((0, _page.useSellHeader)()), (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msas, [client])]);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doPostCtaClick() {
  var flags;
  return _regenerator2.default.wrap(function doPostCtaClick$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_page2.flagSelector);

        case 2:
          flags = _context2.sent;

          if (!flags.headerDropdownOpen) {
            _context2.next = 6;
            break;
          }

          _context2.next = 6;
          return (0, _effects.put)((0, _page.toggleFlag)('headerDropdownOpen'));

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function watchSaga(client) {
  return _regenerator2.default.wrap(function watchSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, ctaClick().type, doPostCtaClick, client);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}